<template>
    <div class="comment-item" :class="index != 0 ? 'mt_10' : ''">
        <!-- 消息项 -->
        <div style="display: flex;">
            <div class="comment_cover">
                <el-image style="width: 60px; height: 90px" :src="item.cover" :zoom-rate="1.2" :max-scale="7"
                    :min-scale="0.2" :preview-src-list="[item.cover]" show-progress :initial-index="4" fit="cover" />
            </div>
            <div style="display: flex; flex-direction: column; flex: 1;margin-left: 15px;">
                <div>
                    <div class="flex_center">
                        <span class="m_color_2" style="font-weight: bold;">
                            {{ item.title }}
                        </span>
                        <el-button type="primary" link @click.stop="handleOpenCommentLink(item.link)"
                            style="margin-left: 10px;">
                            查看笔记
                        </el-button>
                        <div class="comment-time m_desc ml_10">{{ handleDateTimeFormat(item.send_time)
                        }}</div>
                    </div>
                </div>
                <div>

                </div>
                <div class="mt_5" v-if="item.msgtype == 3">
                    <div v-html="handleFormatMsg(item.msg)"></div>
                    <!-- {{ item.msg }} -->
                </div>
                <div v-else-if="item.msgtype == 5">
                    <el-image style="width: 50px; height: 50px" :src="item.msg" :zoom-rate="1.2" :max-scale="7"
                        :min-scale="0.2" :preview-src-list="[item.msg]" show-progress :initial-index="4"
                        fit="fill" />
                </div>

                <!-- 评论回复内容 -->
                <div v-if="item.reply_info?.msg" class="mt_10">
                    <div class="flex_center" style="flex-wrap: wrap;">
                        <div class="m_desc_color">
                            回复：
                        </div>
                        <div v-html="handleFormatMsg(item.reply_info.msg)"></div>
                        <div class="comment-time m_desc ml_10">{{
                            handleDateTimeFormat(item.reply_info.send_time)
                            }}</div>
                    </div>
                </div>
                <div v-else style="flex: 1;display: flex;flex-direction: column;justify-content: flex-end;">
                    <div>
                        <el-button type="primary" link @click="handleEmitShowReply">
                            <template #icon>
                                <i class="iconfont icon-reply" style="margin-right: 2px"></i>
                            </template>
                            回复
                        </el-button>
                    </div>
                </div>
            </div>

        </div>
        <!-- end 消息项 -->
    </div>
</template>

<script>
import { computed, onMounted, ref, watch, inject } from "vue";
import { replaceEmoji } from "@/utils/emoji-util";
import { replaceXhsEmoji } from "@/utils/xhs-emoji-util";
export default {
    props: {
        comment: {
            type: Object, default() {
                return {}
            }
        },
        index: {
            type: Number, default: 0
        }
    },
    emits: ["replyComment"],
    setup(props, { emit,expose }) {
        const $tauriWindow = inject('tauriWindow')
        const momentUtil = inject("momentUtil");
        const item = computed(() => {
            return props.comment || {}
        })
        const index = computed(() => {
            return props.index || {}
        })
        const handleEmitShowReply = async()=>{
            emit("replyComment",item.value.id)
        }
        const handleDateTimeFormat = (dateStr) => {
            if (!dateStr) {
                return '';
            }
            let timeMoment = momentUtil.moment(dateStr, "YYYY-MM-DD HH:mm:ss")
            if (timeMoment.isSame(momentUtil.moment(), "day")) {
                return timeMoment.format('HH:mm')
            }
            return timeMoment.fromNow();
        }

        const handleFormatMsg = (msg) => {
            if (!msg || typeof msg != 'string') {
                return msg;
            }
            msg = msg.replace(/\n/g, "<br>");
            msg = msg.replace(/ /g, "&nbsp;");

            msg = replaceXhsEmoji(msg)
            msg = replaceEmoji(msg);
            return msg;
        };

        const handleOpenCommentLink = (url) => {
            if (!url) {
                return
            }
            $tauriWindow.openWindow(url)
        }

        return {
            item,
            handleFormatMsg,
            handleDateTimeFormat,
            handleOpenCommentLink,
            handleEmitShowReply,
        }
    }
}
</script>


<style scoped lang="scss">
.comment_cover {
    width: 60px;
    height: 90px;
    overflow: hidden;
}

/* 评论 */
.comment-item {
    // border: 1px solid #d9d9d9;
    background-color: #ffffff;
    padding: 10px;
    border-radius: 5px;
}
</style>